import { randomUUID } from '@/lib/random-id';
import {
  safeLocalStorageGetItem,
  safeLocalStorageSetItem,
} from '@/lib/safe-storage';

export const REC_SESSION_ID_KEY = 'rec_session_id';

/**
 * Returns a persistent session ID for recommendation/analytics identity stitching.
 * Generate once, persist in localStorage; clear only on explicit logout.
 */
export function getOrCreateSessionId(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  let id = safeLocalStorageGetItem(REC_SESSION_ID_KEY);
  if (!id) {
    id = randomUUID();
    safeLocalStorageSetItem(REC_SESSION_ID_KEY, id);
  }
  return id;
}
